const textUnderline = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M1.75 12.33h12.5v1.92H1.75zM13.29 1.75v.8l-1.09.58a.8.8 0 0 0-.42.72v3.5a3.88 3.88 0 0 1-4.16 4 4.07 4.07 0 0 1-3.4-4.17V3.85a.8.8 0 0 0-.42-.72l-1.09-.58v-.8h4.53v.8l-1.09.58a.82.82 0 0 0-.42.72v3.51a2.32 2.32 0 0 0 2.72 2.36 2.45 2.45 0 0 0 1.82-2.46V3.85a.82.82 0 0 0-.42-.72l-1.09-.58v-.8z"/></svg>',
};

export { textUnderline as default };
